/** Phase 19 */
import { listAggregateWorkerSessions } from '../infrastructure/storage/domainAggregateStore';
import { listEntityWorkerSessions } from '../infrastructure/storage/entityAggregateStore';
import { createArrayEntityReadSource } from './arrayEntityReadSourceFactory';

const source = createArrayEntityReadSource({
  field: 'workerSessions',
  listAggregate: listAggregateWorkerSessions,
  listEntity: listEntityWorkerSessions,
  idKeys: ['id', 'sessionId']
});

export const readWorkerSessionsFromMergedBlob = source.readFromMergedBlob;
export const readWorkerSessionsFromBestSource = source.readFromBestSource;
export const refreshWorkerSessionsReadCache = source.refreshReadCache;
export const getCachedWorkerSessionsRead = source.getCachedRead;
export const clearWorkerSessionsReadCache = source.clearReadCache;
export const readWorkerSessionsSyncForBusiness = source.readSyncForBusiness;
